import {PROJECT_BASE_PATH} from './multiRunWorkspacePaths';

export const PROJECT_RUNS_REDIRECT_PATH = `${PROJECT_BASE_PATH}/runs`;

export const RUN_BASE_PATH = `${PROJECT_BASE_PATH}/:tab(runs)/:runName`;

export const FULL_SCREEN_RUNS_PANEL_PATH = `${RUN_BASE_PATH}/panel/:panelId`;
export const FULL_SCREEN_RUNS_WORKSPACE_PANEL_PATH = `${RUN_BASE_PATH}/:runTab(workspace)/panel/:panelId`;
export const EMBEDDED_RUNS_PANEL_PATH = `${RUN_BASE_PATH}/embed/panel/:panelId`;

export const RUNS_TAB_PATH = `${RUN_BASE_PATH}/:runTab`;
export const RUN_WORKSPACE_PATH = `${RUN_BASE_PATH}/:runTab(workspace)`;
export const RUN_FILES_PATH = `${RUN_BASE_PATH}/:runTab(files)/:filePath*`;
export const RUN_CODE_FILES_PATH = `${RUN_BASE_PATH}/:runTab(code)/:filePath*`;

export const RUN_WORKSPACE_PATHS = [
  RUN_BASE_PATH,
  RUN_WORKSPACE_PATH,
  FULL_SCREEN_RUNS_PANEL_PATH,
  FULL_SCREEN_RUNS_WORKSPACE_PANEL_PATH,
  EMBEDDED_RUNS_PANEL_PATH,
];

export const RUN_PATHS = [
  ...RUN_WORKSPACE_PATHS,
  RUN_FILES_PATH,
  RUN_CODE_FILES_PATH,
  RUNS_TAB_PATH,
];
